/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     触发器 API
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'
const general_api = process.env.VUE_APP_GENERAL_API_HOST

export function getallTriggerApi(params) {
  return request({
    url: '?c=dev&a=trigger&do=getall',
    method: 'get',
    params
  })
}

export function postTriggerApi(data) {
  return request({
    url: '?c=dev&a=trigger&do=post',
    method: 'post',
    data
  })
}

export function triggerChangeAuthApi(data) {
  return request({
    url: general_api + '/dev/sen/trigger/changeAuth',
    method: 'post',
    data
  })
}
